export const appState = {
  website: null,
  offer: null,
  games: [],
  payments: [],
  providers: [],
};
